module.exports = __webpack_public_path__ + "static/media/Slide20.8afc2f12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slides/Slide20.png
// module id = 1642
// module chunks = 0